import { fetchCaseState } from '@/fetchers/backend-fetchers';
import { useQuery } from '@tanstack/react-query';

export const useHistory = () => {
  const { data: fields } = useQuery({
    queryKey: ['caseState'],
    queryFn: fetchCaseState,
    select: (state) => state.history,
  });
  return fields;
};
